import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/sso.ts
const initSSO = async (context, redirectUrl = "") => {
	return await makeRestApiRequest(context, "GET", `/sso/saml/initsso?redirect=${redirectUrl}`);
};
const getSamlMetadata = async (context) => {
	return await makeRestApiRequest(context, "GET", "/sso/saml/metadata");
};
const getSamlConfig = async (context) => {
	return await makeRestApiRequest(context, "GET", "/sso/saml/config");
};
const saveSamlConfig = async (context, data) => {
	return await makeRestApiRequest(context, "POST", "/sso/saml/config", data);
};
const toggleSamlConfig = async (context, data) => {
	return await makeRestApiRequest(context, "POST", "/sso/saml/config/toggle", data);
};
const testSamlConfig = async (context) => {
	return await makeRestApiRequest(context, "GET", "/sso/saml/config/test");
};
const getOidcConfig = async (context) => {
	return await makeRestApiRequest(context, "GET", "/sso/oidc/config");
};
const saveOidcConfig = async (context, data) => {
	return await makeRestApiRequest(context, "POST", "/sso/oidc/config", data);
};
const initOidcLogin = async (context) => {
	return await makeRestApiRequest(context, "GET", "/sso/oidc/login");
};

//#endregion
export { initSSO as a, testSamlConfig as c, initOidcLogin as i, toggleSamlConfig as l, getSamlConfig as n, saveOidcConfig as o, getSamlMetadata as r, saveSamlConfig as s, getOidcConfig as t };
//# sourceMappingURL=sso.mjs.map